import { render, staticRenderFns } from "./patientIndicatorName.vue?vue&type=template&id=2d61dce9&"
import script from "./patientIndicatorName.vue?vue&type=script&lang=js&"
export * from "./patientIndicatorName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports